/* MR Mouldings — PDP "Complete the look"
 * Fetches every product sharing this product's Profile (custom.profile) via the
 * storefront filter + Section Rendering API, then picks the closest match per
 * category (same design name, same range e.g. Fire Rated / Flexible / Cover).
 */
(function () {
  var root = document.querySelector('[data-ctl]');
  if (!root || root.dataset.ctlInit) return;
  root.dataset.ctlInit = '1';

  var SECTION_FILE = 'pdp-complete-the-look';
  var TYPE_ORDER = ['Skirting', 'Architrave', 'Panel Mould', 'Dado Rail', 'Picture Rail', 'Cornice', 'Window Boards', 'Beading'];
  // Category / material words that are not part of the design name
  var STOP = /^(mdf|skirting|skirtings|board|boards|architrave|architraves|panel|panels|mould|moulds|moulding|mouldings|dado|rail|rails|picture|cornice|cornices|coving|window|windows|fire|rated|flexible|flexi|flex|cover|primed|unprimed|un|timber|pine|oak|and|the|set|kit|copy|beading)$/;

  function tokens(title) {
    return String(title || '').toLowerCase().replace(/&/g, ' ').split(/[^a-z0-9]+/).filter(function (t) { return t && !STOP.test(t); });
  }
  function rangeOf(title, rangeAttr) {
    var t = (String(title || '') + ' ' + String(rangeAttr || '')).toLowerCase();
    if (/fire[\s-]?rated|\bfr\b/.test(t)) return 'fire';
    if (/flexi|flexible/.test(t)) return 'flex';
    if (/\bcover\b/.test(t)) return 'cover';
    return 'std';
  }
  function sameSet(a, b) {
    if (a.length !== b.length) return false;
    return a.every(function (x) { return b.indexOf(x) > -1; });
  }
  function subset(a, b) { return a.every(function (x) { return b.indexOf(x) > -1; }); }

  var current = {
    handle: root.dataset.handle,
    type: root.dataset.type || '',
    design: tokens(root.dataset.title),
    range: rangeOf(root.dataset.title, ''),
    mdf: /\bmdf\b/i.test(root.dataset.title || '')
  };

  function isMdf(title) { return /\bmdf\b/i.test(String(title || '')); }
  // How many of the category's own words appear in the title ("Panel Mould" → panel, mould)
  function typeWordShare(title, type) {
    var words = String(type || '').toLowerCase().split(/[^a-z]+/).filter(Boolean);
    if (!words.length) return 0;
    var t = ' ' + String(title || '').toLowerCase() + ' ';
    var hit = words.filter(function (w) { return t.indexOf(' ' + w) > -1; }).length;
    return hit / words.length;
  }

  function score(item) {
    var s = 0;
    var d = tokens(item.dataset.title);
    if (sameSet(d, current.design)) s += 40;
    else if (subset(current.design, d)) s += 20;
    else if (subset(d, current.design)) s += 15;
    if (rangeOf(item.dataset.title, item.dataset.range) === current.range) s += 10;
    s += 5 * typeWordShare(item.dataset.title, item.dataset.type); // "Ogee MDF Panel Mould" beats "Ogee MDF Beading Moulding" for Panel Mould
    if (isMdf(item.dataset.title) === current.mdf) s += 3;
    if (item.dataset.available === 'true') s += 2;
    return s;
  }

  function typeRank(type) {
    var i = TYPE_ORDER.indexOf(type);
    return i === -1 ? TYPE_ORDER.length : i;
  }

  function choose(items) {
    var limit = parseInt(root.dataset.limit, 10) || 6;
    var onePerType = root.dataset.onePerType === 'true';
    var excludeOwn = root.dataset.excludeOwnType === 'true';

    var pool = items.filter(function (el) {
      if (el.dataset.handle === current.handle) return false;
      if (excludeOwn && current.type && el.dataset.type === current.type) return false;
      return true;
    }).map(function (el) { return { el: el, type: el.dataset.type || '', score: score(el) }; });

    if (!onePerType) {
      return pool.sort(function (a, b) { return b.score - a.score || typeRank(a.type) - typeRank(b.type); }).slice(0, limit).map(function (p) { return p.el; });
    }

    var best = {};
    pool.forEach(function (p) {
      if (!p.type) return;
      if (!best[p.type] || p.score > best[p.type].score) best[p.type] = p;
    });
    return Object.keys(best)
      .sort(function (a, b) { return typeRank(a) - typeRank(b) || a.localeCompare(b); })
      .slice(0, limit)
      .map(function (t) { return best[t].el; });
  }

  var url = root.dataset.url + '?filter.p.m.custom.profile=' + encodeURIComponent(root.dataset.profile) + '&section_id=' + SECTION_FILE;

  fetch(url, { headers: { 'Accept': 'text/html' } })
    .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var items = Array.prototype.slice.call(doc.querySelectorAll('[data-ctl-item]'));
      var picked = choose(items);
      if (!picked.length) return;
      var grid = root.querySelector('[data-ctl-grid]');
      picked.forEach(function (el) { grid.appendChild(document.importNode(el, true)); });
      grid.setAttribute('data-count', String(picked.length));
      root.hidden = false;
    })
    .catch(function () { /* leave hidden */ });
})();
